module.exports = __webpack_public_path__ + "img/cargo-ship.3e81dcf1.jpg";